import apiClient from "./apiClient";

// Create organization
export const createOrganization = async (payload) => {
    try {
        const response = await apiClient.post("/organization", payload, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error creating organization:", error);
        throw error;
    }
};

// Get organization
export const getOrganization = async (page, per_page) => {
    try {
        const response = await apiClient.get(`/organization?page=${page}&per_page=${per_page}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error getting organization:", error);
        throw error;
    }
};

// Get organization by ID
export const getOrganizationById = async (id) => {
    try {
        const response = await apiClient.get(`/organization/${id}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error getting organization by ID:", error);
        throw error;
    }
};

// Update organization
export const updateOrganization = async (id, payload) => {
    try {
        const response = await apiClient.put(`/organization/${id}`, payload, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error updating organization:", error);
        throw error;
    }
};

// Delete Organization
export const deleteOrganization = async (id) => {
    try {
        const response = await apiClient.delete(`/organization/${id}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error deleting Organization:", error);
        throw error;
    }
};

// Create subscription
export const createSubscription = async (payload) => {
    try {
        const response = await apiClient.post("/admin/subscription/organization", payload, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error creating subscription:", error);
        throw error;
    }
};